export const AUTH_COOKIE_NAME = 'tamago_auth_token';
